import { Component } from 'react';
import { myBrowserHistory } from '../ApplicationState';
import libraryStyles from '../SCSS/Library.module.scss';
import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import { Dialog, DialogContent } from '../components/Dialog';

interface Props {
  isShow: boolean;
  onHide: () => void;
  content?: boolean;
  feature?: boolean;
}

export class LockedContentMessage extends Component<Props> {
  render() {
    let noun = 'lesson';

    if (this.props.content) {
      noun = 'content';
    } else if (this.props.feature) {
      noun = 'feature';
    }

    return (
      <Dialog
        open={this.props.isShow}
        onOpenChange={(isOpen) => {
          if (!isOpen) {
            this.props.onHide();
          }
        }}
      >
        <DialogContent
          className='w-[min(95vw,560px)] rounded-[0.6rem] border-0 bg-white p-0 text-[1.6rem] shadow-[0_14px_34px_rgba(0,0,0,0.2)]'
          overlayClassName='bg-black/50'
        >
          <div className='relative border-b-0 px-[2.6rem] pb-[1.2rem] pt-[2.4rem]'>
            <button
              type='button'
              onClick={this.props.onHide}
              aria-label='Close'
              className='absolute right-[1rem] top-[0.7rem] border-0 bg-transparent p-0 text-[2.4rem] leading-none text-[#242424]'
            >
              x
            </button>
            <h3 className='m-0 text-[#242424]'>This is a Peekapak PRO Feature</h3>
          </div>
          <div className='px-[2.6rem] pb-[2.6rem]'>
            <div className="font-['GT-Walsheim-Pro-Light'] text-[1.6rem] text-[#3f3f3f]">
              This {noun} is only available with our Peekapak PRO plan. Want to learn more about it?
            </div>
            <div className='p-[2em] text-center'>
              <PrimaryButton onClick={() => myBrowserHistory.push('/requestInfo')}>Request Information</PrimaryButton>
              <button
                type='button'
                className={`${libraryStyles.textLink} mt-[1rem] border-0 bg-transparent p-0`}
                onClick={() => myBrowserHistory.push('/redeemCode')}
              >
                or upgrade using a license code
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
